export const convertYesNoToBoolean = (value: string) => value === "yes";
